import { PortalDisclaimerComponent } from '../../portal/shared/portal-disclaimer/portal-disclaimer.component';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalValidators } from '../../utils/utils';
import { AccountService } from './../../services/services.module';
import { ScrollToTop } from '../../utils/functions';
import { OpenDialog } from '../../shared/dialogs/dialog';
import { GlobalConfig } from '../../shared/global-config';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnChanges, OnInit {
  userProfile: any;
  sentVeryficationInProgress: boolean;
  @Input() enteredFields;
  @Input() socialLoginUserDetails;
  @Output() changeNIC = new EventEmitter();
  @Output() backToLogin = new EventEmitter();
  @Output() verificationSent = new EventEmitter<boolean>();
  sendVerificationCodeFG: FormGroup;
  verifySignupFG: FormGroup;
  userSignupFG: FormGroup;
  verificationFields: any;
  sentVerification: boolean;
  crmUserRegistrationFailure: boolean;
  signUpFormErrors = false;
  startSignupProcess: boolean;
  verifySignupErrors: any;
  sendVerificationCodeErrors: any;
  verifyingCodeInProgress;
  onUserSignupInProgress;
  signUpError;
  crmUser;
  // requestCaptchaKey: any;
  masterData = {};
  resetOnError = false;
  contactAdministratorInProgress: boolean;
  hideVerificationProcess: boolean;
  successfulMsg;
  verificationExceeded: boolean;
  signUpVerificationAttempts = 0;
  globalConfig = GlobalConfig.countryCode;
  signUpMethod = new FormControl('None');
  userAvailability: any;
  selected: string = 'signup';

  constructor(
    private fb: FormBuilder,
    private accountService: AccountService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    public translate: TranslateService,
    private dialogRef: MatDialog
  ) { }
  ngOnInit(): void {
    this.dialogRef.closeAll();
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes['enteredFields']) {
      if (!!this.enteredFields) {
        this.bindSendVerificationForm(this.enteredFields);
        this.bindVerifySignup(this.enteredFields);
        this.bindUserSignupForm();
      }
    }
  }

  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData || null;
    let pastedText = clipboardData.getData('text');
    const regex = new RegExp('^[a-zA-Z0-9~@.]+$');

    if (!regex.test(pastedText)) {
      event.preventDefault();
      return false;
    }
  }

  restrict(event) {
    const regex = new RegExp('^[a-zA-Z0-9~]+$');
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);

    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }

  bindSendVerificationForm(fields?) {
    if (!fields) {
      fields = { nic: '', passport: '' };
    }
    this.sendVerificationCodeFG = this.fb.group({
      nic: ['', GlobalConfig.countryCode === 'bn' ? GlobalValidators.nicBn : GlobalValidators.nic],
      passport: ['', GlobalValidators.passport],
      brn: [''],
      mobilePhoneCountryCode: ['880', []],
      mobilePhoneAreaCode: ['', [GlobalValidators.pattern(/\d{3}/i), GlobalValidators.required]],
      mobilePhoneNumber: [
        '',
        [
          GlobalValidators.requireIfTrue('mobilePhoneAreaCode'),
          GlobalValidators.pattern(GlobalConfig.countryCode === 'bn' ? /\d{7}/i : /\d{6}/i, 'mobilePhoneCountryCode'),
        ],
      ],
      email: [
        {
          value: this.socialLoginUserDetails ? this.socialLoginUserDetails.email : '',
          disabled: this.socialLoginUserDetails && this.socialLoginUserDetails.email,
        },
        [GlobalValidators.email, GlobalValidators.required],
      ],
    });

    this.sendVerificationCodeFG.valueChanges.subscribe((value) => {
      this.userAvailability = false;
      this.signUpError = undefined;
      this.sentVeryficationInProgress = false;
      this.sentVerification = false;
      this.sendVerificationCodeErrors = undefined;
      this.verificationExceeded = false;
      this.verifySignupErrors = [];
      this.signUpVerificationAttempts = 0;
      this.contactAdministratorInProgress = false;
      this.verifySignupFG.reset({ nic: '', passport: '', brn: '', verificationCode: '' });
      // if (!this.verificationExceeded) {
      //   this.sendVerificationCodeErrors = undefined;
      // }
    });
  }

  get useTranslation() {
    let translation = '';
    if (this.globalConfig === 'bn') {
      this.translate.get('sign_up.tel_no_bn').subscribe((res) => {
        translation = res;
      });
    } else {
      this.translate.get('sign_up.tel_no').subscribe((res) => {
        translation = res;
      });
    }
    return translation;
  }

  bindVerifySignup(fields?) {
    if (!fields) {
      fields = { nic: '', passport: '', brn: '' };
    }

    this.verifySignupFG = this.fb.group({
      nic: [''],
      passport: [''],
      brn: [''],
      verificationCode: ['', [Validators.required]],
    });
    this.verifySignupFG.valueChanges.subscribe((value) => {
      this.verifySignupErrors = undefined;
    });

    this.signUpMethod.valueChanges.subscribe((r) => {
      this.sendVerificationCodeFG.get('nic').reset('');
      this.sendVerificationCodeFG.get('passport').reset('');
      this.signUpError = undefined;
      this.sentVeryficationInProgress = false;
      this.sentVerification = false;
      this.sendVerificationCodeErrors = undefined;
      this.verificationExceeded = false;
      this.verifySignupErrors = [];
      this.signUpVerificationAttempts = 0;
      this.contactAdministratorInProgress = false;
      this.verifySignupFG.reset({ nic: '', passport: '', brn: '', verificationCode: '' });
    });
  }

  bindUserSignupForm(profile?) {
    if (profile && profile.firstName) {
      this.crmUser = true;
    } else {
      profile = {};
    }
    if (!this.enteredFields) {
      this.enteredFields = { nic: '', passport: '' };
    }
    this.userSignupFG = this.fb.group(
      {
        firstName: [
          {
            value:
              profile.firstName ||
              (this.socialLoginUserDetails ? this.socialLoginUserDetails.firstName || this.socialLoginUserDetails.name.split(' ')[0] : ''),
            disabled: false,
          },
          [Validators.required],
        ],
        lastName: [
          {
            value:
              profile.lastName ||
              (this.socialLoginUserDetails ? this.socialLoginUserDetails.lastName || this.socialLoginUserDetails.name.split(' ')[1] : ''),
            disabled: false,
          },
          [Validators.required],
        ],
        verificationCode: [this.verifySignupFG.get('verificationCode').value, [Validators.required]],
        nic: [this.sendVerificationCodeFG.get('nic').value || ''],
        email: [this.sendVerificationCodeFG.get('email').value || ''],
        mobilePhoneCountryCode: [this.sendVerificationCodeFG.get('mobilePhoneCountryCode').value || '', []],
        mobilePhoneAreaCode: [this.sendVerificationCodeFG.get('mobilePhoneAreaCode').value || '', []],
        mobilePhoneNumber: [this.sendVerificationCodeFG.get('mobilePhoneNumber').value || '', []],
        passport: [this.sendVerificationCodeFG.get('passport').value || ''],
        brn: [this.enteredFields.brn || ''],
        password: ['', [Validators.required, GlobalValidators.password()]],
        confirmPassword: ['', [Validators.required]],
        termsCondition: ['', [GlobalValidators.requiredToBeTruthy]],
        // captchaResponse: [''],
        // captchaText: [, Validators.required]
        captchaAttempts: [1],
      },
      {
        validator: GlobalValidators.misMatchPasswords('password', 'confirmPassword'),
      }
    );
    this.userSignupFG.valueChanges.subscribe((value) => {
      this.signUpError = undefined;
      this.sentVeryficationInProgress = false;
      this.sentVerification = false;
      this.sendVerificationCodeErrors = undefined;
      this.verificationExceeded = false;
      this.verifySignupErrors = [];
      this.verifySignupFG.reset({ nic: '', passport: '', brn: '', verificationCode: '' });
    });
  }

  validateCrossFields(group: FormGroup) {
    const email = group.controls['email'];
    const mobile = group.controls['mobileNo'];
    if (email.value || mobile.value) {
      this.signUpFormErrors = false;
    }

    // return null;
  }

  async checkUser(userId, type) {
    let { isExistingUser } = await this.accountService.isAvailableUser(userId, type);
    return isExistingUser;
  }

  async onSendSignupVerificationCodes(form) {
    console.log(this.signUpVerificationAttempts);
    this.verificationExceeded = (this.signUpVerificationAttempts > 0 && true) || false;
    this.sendVerificationCodeErrors = undefined;
    this.verifySignupErrors = [];
    if (form.invalid) {
      this.signUpFormErrors = true;
      return;
    }

    try {
      if (this.sendVerificationCodeFG.get('nic').value || this.sendVerificationCodeFG.get('passport').value) {
        this.userAvailability = await this.checkUser(
          this.sendVerificationCodeFG.get('nic').value || this.sendVerificationCodeFG.get('passport').value,
          this.signUpMethod.value
        );
        if (this.userAvailability) {
          return;
        }
      }
    } catch (e) { }

    try {
      this.sentVeryficationInProgress = true;
      this.crmUserRegistrationFailure = false;
      let result = await this.accountService.sendVerificationCodes(this.sendVerificationCodeFG.getRawValue());
      this.sentVerification = true;
      this.verificationSent.emit(true);
      console.log('sentVerification set to true');
      this.sentVeryficationInProgress = false;
      // Force change detection to ensure the slide animation triggers
      setTimeout(() => {
        this.cdRef.detectChanges();
      }, 10);
      this.sendVerificationCodeErrors = undefined;
    } catch (e) {
      ++this.signUpVerificationAttempts;
      this.verificationExceeded = (this.signUpVerificationAttempts > 0 && true) || false;
      this.crmUserRegistrationFailure = true;
      this.sentVerification = false;
      console.log('sentVerification set to false (error case)');
      this.sentVeryficationInProgress = false;
      if (e.error.message?.indexOf('Details you Entered are incorrect. Please contact administrator.') >= 0) {
        this.sendVerificationCodeErrors = [
          'Details you have entered do not match with our records, please click the below button to contact the Administrator or try again.',
        ];
      } else if (e.error.message?.indexOf('A registered user for') >= 0) {
        this.sendVerificationCodeErrors = e.error.message;
      } else if (e.error.message?.indexOf('Invalid identification details') >= 0) {
        this.sendVerificationCodeErrors = e.error.message;
      } else {
        this.sendVerificationCodeErrors = e.error.message || 'Network error occured. Please Try Again';
      }
    }
    this.cdRef.detectChanges();
  }

  onVerifySignup(form) {
    if (form.invalid) {
      return;
    }

    this.verifyingCodeInProgress = true;
    this.accountService
      .verifySignUpCode({ email: this.sendVerificationCodeFG.get('email').value, ...form.value })
      .then(({ profile }) => {
        this.verifySignupErrors = [];
        this.bindUserSignupForm(profile);
        ScrollToTop();
        this.startSignupProcess = true;
        this.verifyingCodeInProgress = false;
        this.cdRef.detectChanges();
      })
      .catch((e) => {
        this.verifyingCodeInProgress = false;
        if (e.error.message.indexOf('This account has temporarily blocked. Maximum verification attempts exceeded.') >= 0) {
          this.verifySignupErrors = ['This account has temporarily blocked. Maximum verification attempts exceeded.'];
          this.verificationExceeded = true;
        } else {
          this.verifySignupErrors = ['Incorrect verification code'];
        }
        this.cdRef.detectChanges();
      });
    this.cdRef.detectChanges();
  }

  async onUserSignup(form) {
    if (form.invalid) {
      return;
    }
    this.resetOnError = false;
    this.onUserSignupInProgress = true;
    this.signUpError = undefined;
    try {
      let data = await this.accountService.signUp({
        ...form.value,
        socialLoginProvider: (this.socialLoginUserDetails && this.socialLoginUserDetails.provider) || '',
        socialLoginAuthToken: (this.socialLoginUserDetails && this.socialLoginUserDetails.authToken) || '',
      });
      this.onUserSignupInProgress = false;
      await this.accountService.updatePortalDiscalimer();
      if (this.router.url.indexOf('ipo') > -1 || this.router.url.indexOf('debenture-issue') > -1) {
        this.accountService.emitLoginStatus(true);
      } else {
        let currentUser = await this.accountService.currentUserAsync();
        this.router.navigate([`/dashboard`], { queryParams: { uid: `${currentUser.id}`, newUser: `true` } });
      }
    } catch (e) {
      this.onUserSignupInProgress = false;
      this.resetOnError = true;
      // Handle different error response formats
      if (e.error && e.error.message) {
        this.signUpError = e.error.message;
      } else if (e.error && typeof e.error === 'string') {
        this.signUpError = e.error;
      } else if (e.message) {
        this.signUpError = e.message;
      } else {
        this.signUpError = 'An error occurred while creating your account. Please try again.';
      }
      console.error('Signup error:', e);
    }

    this.cdRef.detectChanges();
  }

  changeNic() {
    this.changeNIC.emit();
  }

  goToLogin() {
    this.backToLogin.emit();
    this.startSignupProcess = false;
  }

  goToLoginPage() {
    this.backToLogin.emit();
    this.router.navigate(['/signin']);
  }
  contactAdmin() {
    this.contactAdministratorInProgress = true;
    this.accountService
      .requestResetPassword({
        nic: this.sendVerificationCodeFG.get('nic').value || '',
        passport: this.sendVerificationCodeFG.get('passport').value || '',
      })
      .then(() => {
        this.hideVerificationProcess = true;
        this.contactAdministratorInProgress = false;
        this.successfulMsg = true;
      });
  }
  openDisclaimer() {
    OpenDialog(PortalDisclaimerComponent, { close: true, accept: true, guestpopup: true });
  }
}
